import React, { useState, Fragment } from 'react'
import { FormikInputLabel } from '@pga/pga-component-library'
import { PaymentElement } from '@stripe/react-stripe-js'
import styled from 'styled-components'
import { StyledButton, StyledInputField, FormContainer } from '../../shared.styles'
import emailValidator from 'email-validator'

import { LoadingModal } from './LoadingModal'
import { withAuthProvider } from '../../../lib/auth'

const StripeInput = styled(PaymentElement)`
  padding: 0.5rem 0.75rem;
  margin: 16px 0px 0px 0px;
  border: 1px solid ${props => props.theme.colors.pearlGrey};
  border-radius: 0;
`

const PaymentForm = ({ formData, handleChange, handleSubmit, isLoggedIn, authReady }) => {
  const [complete, setComplete] = useState(false)
  const { email, formSubmitted, firstName, lastName, address, onBehalf, stripeError } = formData

  const loggedOutInputOptions = [
    { id: 'firstName', value: firstName, label: 'First Name' },
    { id: 'lastName', value: lastName, label: 'Last Name' },
    { id: 'address', value: address, label: 'Address' },
    { id: 'onBehalf', value: onBehalf, label: 'On Behalf of/In Memory of' }
  ]

  const handleChangeStripe = e => {
    if (e.complete !== complete) setComplete(e.complete)
  }

  const paymentElementOptions = {
    layout: 'tabs',
    paymentMethodOrder: ['card', 'us_bank_account'],
    wallets: {
      applePay: 'never',
      googlePay: 'never'
    }
  }

  return (
    <FormContainer>
      <h3>Billing Information</h3>
      <FormikInputLabel field='email'>Email</FormikInputLabel>
      <StyledInputField
        error={!emailValidator.validate(email)}
        id='email'
        value={email}
        onChange={handleChange('email')}
      />
      {
        authReady
          ? !isLoggedIn && (
            <>
              {
                loggedOutInputOptions.map(({ id, value, label }, key) => (
                  <Fragment key={key}>
                    <FormikInputLabel field={id}>{label}</FormikInputLabel>
                    <StyledInputField
                      id={id}
                      value={value}
                      onChange={handleChange(id)}
                    />
                  </Fragment>
                ))
              }
            </>
            )
          : null
      }

      <StripeInput onChange={handleChangeStripe} options={paymentElementOptions} />

      {
        formSubmitted
          ? <LoadingModal />
          : <StyledButton disabled={!complete || !emailValidator.validate(email)} onClick={handleSubmit}>Submit</StyledButton>
      }
      {stripeError && stripeError.message ? <p className='text-danger mt-3'>{stripeError.message}</p> : null}
    </FormContainer>
  )
}

export default withAuthProvider(PaymentForm)
